import { usePartyLicensesQuery } from "Api/Queries/Licenses/usePartyLicensesQuery";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { isLicenseActive } from "Utils/LicenseUtils";
import { useCallback, useMemo } from "react";

export const useMerchantOwnership = () => {
  const user = useLoggedInUser();
  const { data: licensesData, isLoading } = usePartyLicensesQuery(
    user?.partyPublicID,
  );

  const ownedLicensePublicIDs = useMemo(
    () =>
      licensesData?.items?.filter(isLicenseActive).map((l) => l.publicID) || [],
    [licensesData],
  );

  const isMerchantOwned = useCallback(
    (merchantLicensePublicID?: string | null) =>
      !!merchantLicensePublicID &&
      ownedLicensePublicIDs.includes(merchantLicensePublicID),
    [ownedLicensePublicIDs],
  );

  return { isMerchantOwned, isLoading, ownedLicensePublicIDs };
};
